import { render, staticRenderFns } from "./QuotationFormSenderNote.vue?vue&type=template&id=5194797b&"
import script from "./QuotationFormSenderNote.vue?vue&type=script&lang=js&"
export * from "./QuotationFormSenderNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5194797b')) {
      api.createRecord('5194797b', component.options)
    } else {
      api.reload('5194797b', component.options)
    }
    module.hot.accept("./QuotationFormSenderNote.vue?vue&type=template&id=5194797b&", function () {
      api.rerender('5194797b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/RequestAQuote/QuotationForm/QuotationFormSenderNote.vue"
export default component.exports